import { RichText } from '@omnia/ui/src/lib/cms/components/richText/RichText'
import type { GridElement } from '@omnia/ui/src/lib/cms/grid/interfaces/gridElement'
import { Accordion } from '@vista-digital/occ-ui/src/lib/subcomponents/accordion/accordion'
import { AccordionSection } from '@vista-digital/occ-ui/src/lib/subcomponents/accordion/subcomponents/section'
import type { FC } from 'react'
import type { AccordionItemsPropsApi } from '@/features/grid/accordion/models'

export const GridAccordion: FC<GridElement<AccordionItemsPropsApi[]>> = ({ value }) => {
    return (
        <Accordion headingLevel={'h5'}>
            {value.map((item, index) => (
                <AccordionSection key={index} title={item.heading} id={`${index}`}>
                    <RichText htmlText={item.body} />
                </AccordionSection>
            ))}
        </Accordion>
    )
}
